import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosDummyInstance } from '@utils/axios/axiosInstance';
import { reduxThunkStatus } from '@configs/restApi';
import { keywordType, keywordGroupType, competitorsType } from '@models/keyword/keywordModel';
import { gridOptionModel } from '@models/gridModel';
import { ITestResultKeywordType, ICompetitorKeywordType } from '@models/keyword/keywordModel';
import { requestType } from '@models/keyword/keyword';

import {
  fetchSearchBoxData,
  fetchAnalysisBoxData,
  fetchCompetitorBoxData,
  fetchReqKeyword,
  fetchDescriptionSearchBox,
  fetchDescriptionAddDelButton,
  fetchDescriptionAddDelHeader,
} from '@reducers/keyword/thunk/optimizationThunk';

// TODO: 임시함수임.. 추후 삭제할것
const makeKeywordsObjList = (keywordsList) => {
  return keywordsList.map((item, index) => ({
    ...item,
    searchscore: Math.floor(Math.random() * 100),
    rank: Math.floor(Math.random() * 1000),
    title: [true, false][Math.round(Math.random())],
    sub: [true, false][Math.round(Math.random())],
    asck: [true, false][Math.round(Math.random())],
    group: [null, 'group1', 'group2', 'group3', 'group4'][Math.round(Math.random() * 10) % 4],
    missingkeyword: `test${index}`,
  }));
};

const initialState = {
  // Test 버튼 후 나오는 gridData
  searchBoxList: null as ITestResultKeywordType[],
  // keyword Density gridData
  analysisBoxList: null,
  // competitor gridData
  competitorBoxList: null as ICompetitorKeywordType[],
  // description AppList (description 에서 헤더의 선택한 앱 리스트)
  appList: [] as { id: string; appTitle: string }[],
};

export const keywordOptimizationSlice = createSlice({
  name: 'keywordOptimization',
  initialState: initialState,
  reducers: {
    setAnalysisBoxList: (state, { payload }: { payload: { data: string[] | null } }) => {
      state.analysisBoxList = payload.data;
    },
  },
  extraReducers: {
    // searchBox GridData 요청
    [fetchSearchBoxData.fulfilled.type]: (state, { payload }) => {
      state.searchBoxList = payload;
    },
    // analysisBox GridData 요청
    [fetchAnalysisBoxData.fulfilled.type]: (state, { payload }) => {
      state.analysisBoxList = payload;
    },
    // competitorBox GridData 요청
    [fetchCompetitorBoxData.fulfilled.type]: (state, { payload }) => {
      console.log('paylaod77777: ', payload);
      state.competitorBoxList = payload;
    },
    // searchBox, analysisBox keyword add/Del 요청
    [fetchReqKeyword.fulfilled.type]: (state, { payload, meta: { requestStatus } }) => {
      console.log('paylaod789789: ', payload);
      const { userId, tabType, reqType, boxType, keyword, group, keywordId } = payload.params;
      if (boxType === 'searchBox') {
        // 아래는 기존 searchBox 데이터 변경로직
        const objIndex = state.searchBoxList.findIndex((item) => item.id === keywordId);
        if (reqType === 'add') {
          // request가 add 이므로 del 로 바꿔야 한다.(true)
          state.searchBoxList[objIndex].tracked = true;
        } else if (reqType === 'del') {
          // request가 del 이므로 add로 바꿔야 한다.(false)
          state.searchBoxList[objIndex].tracked = false;
        }

        // 아래는 analysisBox 데이터 변경로직
        if (state?.analysisBoxList?.length > 0) {
          const objIndex = state.analysisBoxList.findIndex((item) => item.id === keywordId);
          if (objIndex > -1) {
            if (reqType === 'add') {
              // request가 add 이므로 del 로 바꿔야 한다.(true)
              state.analysisBoxList[objIndex].tracked = true;
            } else if (reqType === 'del') {
              // request가 del 이므로 add로 바꿔야 한다.(false)
              state.analysisBoxList[objIndex].tracked = false;
            }
          }
        }
      } else if (boxType === 'analysisBox') {
        // 아래는 기존 analysisBox 데이터 변경로직
        const objIndex = state.analysisBoxList.findIndex((item) => item.id === keywordId);
        if (reqType === 'add') {
          // request가 add 이므로 del 로 바뀌어야 한다.(true)
          state.analysisBoxList[objIndex].tracked = true;
        } else if (reqType === 'del') {
          // request가 del 이므로 add로 바꿔야 한다.(false)
          state.analysisBoxList[objIndex].tracked = false;
        }

        // 아래는 기존의 searchBox 데이터 add/del 아이콘 변경로직
        if (state.searchBoxList?.length > 0) {
          const objIndex = state.searchBoxList.findIndex((item) => item.id === keywordId);
          if (objIndex > -1) {
            if (reqType === 'add') {
              // request 가 add 이므로 del 로 바꿔야 한다.(true)
              state.searchBoxList[objIndex].tracked = true;
            } else if (reqType === 'del') {
              // request가 del 이므로 add로 바꿔야 한다.(false)
              state.searchBoxList[objIndex].tracked = false;
            }
          }
        }
      }
      // 가져온 데이터 competitorsData에 반영!
      state.competitorBoxList = payload.competitorsData;
    },

    // Description AnalysisBox 데이터 (최초요청)
    [fetchDescriptionSearchBox.fulfilled.type]: (state, { payload }) => {
      state.analysisBoxList = payload;
      state.appList = [];
    },

    // Description Add/Del keyword Button
    [fetchDescriptionAddDelButton.fulfilled.type]: (state, { payload }) => {
      const { competitorsData, params } = payload;
      //// analysisBoxList add/del 아이콘 변경처리
      const { userId, reqType, tabType, boxType, keywordId, keyword } = params;
      const objIndex = state.analysisBoxList.findIndex((item) => item.id === keywordId);
      if (reqType === 'add') {
        // request 가 add 이므로 del 로 바꿔야 한다.(true)
        state.analysisBoxList[objIndex].tracked = true;
      } else if (reqType === 'del') {
        // request가 del 이므로 add로 바꿔야 한다.(false)
        state.analysisBoxList[objIndex].tracked = false;
      }

      // //// 헤더 앱 포함된 keyword 모두 선택시 헤더 아이콘 변경처리!
      // // 1) 선택된 keywordObj 뽑기
      // const filterAddedData = state.analysisBoxList.filter((item) => item.tracked === true);
      // console.log('filterAddedData: ', filterAddedData);
      // // 2) 전체 appList 를 뽑기
      // let tempAppList = state.analysisBoxList[0].appObj.map((item) => item.appTitle);
      // // 3) 1)의 데이터에서 카운트 30이하는(*추후 조건 바꾸기 0일때 같은걸로..) appList에서 제외시키기
      // filterAddedData.forEach((item) => {
      //   item.appObj.forEach((appItem) => {
      //     if (appItem.count < 30) {
      //       console.log('appItem: ', appItem);
      //       tempAppList = tempAppList.filter((temp) => temp !== appItem.appTitle);
      //     }
      //   });
      // });
      // // 4) 3)의 과정을 거친 2)를 기존 리덕스 appList에 포함시키고(concat) 중복제거처리 후 리덕스 저장
      // let resultAppList = state.appList.concat(tempAppList);
      // let resultAppList1 = Array.from(new Set(resultAppList));
      // console.log('resultAppList: ', resultAppList1);
      // state.appList = resultAppList1;

      //// 가져온 데이터 competitorsData에 반영!
      // state.competitorBoxList = competitorsData; // TODO: api 붙일땐 주석 풀기
      // TODO: 아래 추가 삭제코드는 api 붙일땐 삭제처리할것..
      if (reqType === 'add') {
        state.competitorBoxList = competitorsData.concat(makeKeywordsObjList([{ keyword: keyword, id: keywordId }]));
      } else if (reqType === 'del') {
        state.competitorBoxList = state.competitorBoxList.filter((item) => {
          return item.id !== keywordId;
        });
      }
    },

    // Description Add/Del App Header
    [fetchDescriptionAddDelHeader.fulfilled.type]: (state, { payload }) => {
      const { competitorsData, params } = payload;

      const { userId, tabType, reqType, boxType, appId, appTitle } = params;
      //// analysisBoxList add/del 헤더 아이콘 변경처리
      const tempAppList = state.appList; // TODO: 삭제하기
      // reqType 에 따라 appList 추가/제거하기
      let resultAppList;
      if (reqType === 'add') {
        resultAppList = state.appList.concat({ id: appId, appTitle: appTitle });
        state.appList = resultAppList;
      } else if (reqType === 'del') {
        resultAppList = state.appList.filter((item) => item.id !== appId);
        state.appList = resultAppList;
      }

      //// analysisBoxList add/del 키워드 아이콘 변경처리
      // 1) list 뽑기 count 30이상인 analysisBoxList keyword list id로뽑기
      const keywordIdlist = state.analysisBoxList
        .filter((obj) => {
          // obj.appObj 에서 resultAppList에 포함된 index 를 arr로 모음
          const appObjArr = obj.appObj.filter((item) => resultAppList.map((it) => it.id).includes(item.appId));
          return appObjArr.some((app) => app.count > 30);
        })
        .map((item) => item.id);
      // 2) listData 에 keyword 가 포함되면 true 표시하기
      state.analysisBoxList = state.analysisBoxList.map((item) => ({
        ...item,
        tracked: keywordIdlist.includes(item.id),
      }));

      //// 가져온 데이터 competitorsData에 반영!
      // state.competitorBoxList = competitorsData; // TODO: api 붙일땐 주석 풀기
      // TODO: 아래 추가 삭제코드는 api 붙일땐 삭제처리할것..
      if (reqType === 'add') {
        const addListData = state.analysisBoxList
          .filter((obj) => {
            // obj.appObj 에서 resultAppList에 포함된 index 를 arr로 모음
            const appObjArr = obj.appObj.filter((item) => resultAppList.map((it) => it.id).includes(item.appId));
            return appObjArr.some((app) => app.count > 30);
          })
          .map((item) => ({ id: item.id, keyword: item.keyword }));

        state.competitorBoxList = competitorsData.concat(makeKeywordsObjList(addListData));
      } else if (reqType === 'del') {
        // TODO: 아래의 코드가 적용되려면... appList 를 삭제하기 전에 처리해야 하므로 위치를 바꿔야한다.
        const keywordIdlist = state.analysisBoxList
          .filter((obj) => {
            // obj.appObj 에서 resultAppList에 포함된 index 를 arr로 모음
            const appObjArr = obj.appObj.filter((item) => tempAppList.map((it) => it.id).includes(item.appId));
            return appObjArr.some((app) => app.count > 30);
          })
          .map((item) => item.id);
        state.competitorBoxList = state.competitorBoxList.filter((item) => {
          return !keywordIdlist.includes(item.id);
        });
      }
    },
  },
});

export const { setAnalysisBoxList } = keywordOptimizationSlice.actions;
export const keywordOptimizationSliceName = keywordOptimizationSlice.name;
export default keywordOptimizationSlice.reducer;
